export const resetAction = ({ dispatch, action }) => dispatch({ type: `${action}_API_RESET` })
